import { render, staticRenderFns } from "./ModalAdjustDiscount.vue?vue&type=template&id=4564d9b6&scoped=true"
import script from "./ModalAdjustDiscount.vue?vue&type=script&lang=js"
export * from "./ModalAdjustDiscount.vue?vue&type=script&lang=js"
import style0 from "./ModalAdjustDiscount.vue?vue&type=style&index=0&id=4564d9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564d9b6",
  null
  
)

export default component.exports